import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
declare function init_plugins();

@Component({
  selector: 'app-nopagefound',
  templateUrl: './nopagefound.component.html',
  styleUrls: ['./nopagefound.component.css']
})

export class NopagefoundComponent implements OnInit {

  constructor(private location: Location) { }

  navigateBack() {
    this.location.back();
  }

  ngOnInit() {}
}
